import React from 'react';
import img from '../../images/banner.png'
const Banner = () => {
    return (
        <div className="carousel w-full">
            <img  src={img} alt="" />
               
        </div>
    );
};

export default Banner;